import {Component} from '@angular/core';
import {BsModalService} from 'ngx-bootstrap/modal';
import {BsModalRef} from 'ngx-bootstrap';
import {ModalFields} from '../../models/modal-fields';
import {Field} from '../../models/crud/Field';
import {Config} from '../../models/crud/Config';
import {AngularFireDatabase} from 'angularfire2/database';
import {TranslateService} from "@ngx-translate/core";
import {MatSnackBar} from "@angular/material";

@Component({
    selector: 'app-template-modal',
    template: `
        <div class="modal-header">
            <h4 class="modal-title pull-left">{{_model.config.title | translate}}</h4>
            <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <form #formModel='ngForm'>
                <div class="container-form small row">
                    <div *ngFor="let field of _model.fields" class="input-group fullWith {{field.class||'col-12'}}">
                        <ng-container *ngIf="!field.hidden" class="row">
                            <mat-form-field *ngIf="field.type == 'text'" class="fullWith">
                                <input matInput
                                       type="text"
                                       name="{{field.name}}"
                                       [(ngModel)]="field.value"
                                       [required]="field.required"
                                       [placeholder]="field.label|translate"/>
                            </mat-form-field>
                            <mat-checkbox *ngIf="field.type == 'checkbox'" class="mV10 fullWith"
                                          [(ngModel)]="field.value"
                                          name="{{field.name}}"
                                          [required]="field.required">{{field.label | translate}}
                            </mat-checkbox>
                            <div *ngIf="field.type == 'image'" class="fullWith">
                                <img [src]="field.value" height="90"
                                     onerror="this.src='https://firebasestorage.googleapis.com/v0/b/time-tracker-82e5f.appspot.com/o/empty_team.png?alt=media&token=079e49b9-234d-4a8b-8d25-62a9c5db89f6';this.onerror=null">
                                <input class="small" type="file" accept="image/jpeg,image/png"
                                       [ngModel]="field.valueTemp"
                                       name="{{field.name}}"
                                       (change)="readUrl($event, field)"/>
                            </div>
                            <mat-form-field *ngIf="field.type == 'select'" class="fullWith">
                                <mat-select
                                    [placeholder]="field.label|translate"
                                    [(ngModel)]="field.value"
                                    [required]="field.required"
                                    name="{{field.name}}">
                                    <mat-option *ngFor="let option of field.entries" [value]="option.key">
                                        {{option.value | translate}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <mat-form-field *ngIf="field.type == 'date'" class="fullWith">
                                <input matInput [matDatepicker]="mdate" [(ngModel)]="field.value"
                                       name="{{field.name}}"
                                       [required]="field.required" [placeholder]="field.label|translate">
                                <mat-datepicker-toggle matSuffix [for]="mdate"></mat-datepicker-toggle>
                                <mat-datepicker #mdate></mat-datepicker>
                            </mat-form-field>
                            <mat-form-field *ngIf="field.type == 'time'" class="fullWith">
                                <input matInput type="time" class="small" [(ngModel)]="field.value"
                                       name="{{field.name}}"
                                       [placeholder]="field.label|translate"/>
                            </mat-form-field>
                        </ng-container>
                    </div>
                </div>
            </form>
        </div>
        <div class="modal-footer">
            <button mat-raised-button type="button" (click)="bsModalRef.hide()">
                {{_model.config.cancelLabel | translate}}
            </button>

            <ng-container *ngIf="_model.mode_delete">
                <button mat-raised-button color="warn" type="button" (click)="delete()"
                        [disabled]="disableBtnDelete">
                    {{_model.config.deleteLabel | translate}}
                </button>
            </ng-container>

            <ng-container *ngIf="_model.mode_edit">
                <button mat-raised-button color="accent" type="button" (click)="update(formModel)"
                        [disabled]="disableBtnUpdate">
                    {{_model.config.updateLabel | translate}}
                </button>
            </ng-container>

            <ng-container *ngIf="_model.mode_create">
                <button mat-raised-button color="accent" type="button" (click)="create(formModel)"
                        [disabled]="disableBtnCreate">
                    {{_model.config.createLabel | translate}}
                </button>
            </ng-container>
        </div>
    `,
    providers: [BsModalService]
})

export class ReasonModalComponent {
    public _model: ModalFields;
    private disableBtnCreate;
    private disableBtnUpdate;
    private disableBtnDelete;

    constructor(public bsModalRef: BsModalRef, public af: AngularFireDatabase, public trans: TranslateService, public snackBar: MatSnackBar) {
        this._model = new ModalFields(
            [],
            new Config('Time Tracker'),
            false, false, false
        );
        this.disableBtnCreate = false;
        this.disableBtnUpdate = false;
        this.disableBtnDelete = false;
    }

    set model(value: ModalFields) {
        console.log('set Model', value);
        value.fields.forEach(field => {
            if (field.type === 'date') {
                field.value = new Date(field.value);
            }
        });
        this._model = value;
    }

    public submitForm(form) {
        console.log('submitForm--> ', form);
    }

    public create(form) {
        console.log('--->formInfo: ', form);
        if (!form.valid) {
            this.trans.get('PLEASE_SET_VALID_DATA').subscribe((res: string) => {
                this.snackBar.open(res, null, {duration: 2500});
            });
            return;
        }
        let object: any = {};
        this._model.fields.forEach(function (field) {
            if (field.value !== null && field.value !== undefined) {
                if (field.type === 'date') {
                    object[field.name] = (field.value || new Date()).getTime();
                } else {
                    object[field.name] = field.value;
                }
            }
        });
        console.log('Click to create', object);
        object.id = this.guid();
        this.disableBtnCreate = true;
        this.af.database.ref(this._model.firebaePath + '/' + object.id)
            .update(object);
        this.bsModalRef.hide();
    }

    public update(form) {
        console.log('--->formInfo: ', form);
        if (!form.valid) {
            this.trans.get('PLEASE_SET_VALID_DATA').subscribe((res: string) => {
                this.snackBar.open(res, null, {duration: 2500});
            });
            return;
        }

        let object: any = {};
        this._model.fields.forEach(function (field) {
            if (field.value !== null && field.value !== undefined) {
                if (field.type === 'date') {
                    object[field.name] = (field.value || new Date()).getTime();
                } else {
                    object[field.name] = field.value;
                }
            }
        });
        console.log('Click to edit', object);
        this.disableBtnUpdate = true;

        this.af.database.ref(this._model.firebaePath + '/' + object.id)
            .update(object);
        this.bsModalRef.hide();
    }

    public delete() {
        let object: any = {};
        this._model.fields.forEach(function (field) {
            if (field.value !== null && field.value !== undefined) {
                object[field.name] = field.value;
            }
        });
        console.log('Click to delete', this._model.firebaePath + '/' + object.id, object);
        this.disableBtnDelete = true;
        this.af.object(this._model.firebaePath + '/' + object.id).remove();
        this.bsModalRef.hide();
    }

    /**
     * Function to preview image file
     * @param event
     * @param {Field} field
     */
    readUrl(event: any, field: Field) {
        if (event.target.files && event.target.files[0]) {
            let reader = new FileReader();
            reader.onload = (event: any) => {
                field.value = event.target.result;
            };
            reader.readAsDataURL(event.target.files[0]);
        }
    }

    private guid() {
        function _p8(s) {
            let p = (Math.random().toString(16) + '000000000').substr(2, 8);
            return s ? '-' + p.substr(0, 4) + '-' + p.substr(4, 4) : p;
        }

        return _p8(false) + _p8(true) + _p8(true) + _p8(false);
    }
}



// WEBPACK FOOTER //
// ./src/app/modals/template-reason-modal.ts